module.exports = __webpack_public_path__ + "static/media/spring.9621ef72.jpg";